import * as GetHomeBannerTypes from 'src/actions/home-banner/get/Types';
import {
  GetHomeBannerAction,
  GetHomeBannerSuccess
} from 'src/actions/home-banner/get/GetHomeBanner.actions';
import HomeBanner from 'src/entities/HomeBanner';

export interface GetHomeBannerState {
  homeBanner?: HomeBanner;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetHomeBannerState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetHomeBannerReducer(state: GetHomeBannerState = initialState,
                                     action: GetHomeBannerAction):
  GetHomeBannerState {
  switch (action.type) {
    case GetHomeBannerTypes.GET_HOME_BANNER_ATTEMPT:
      return {...state, homeBanner: undefined, loading: true, error: false};
    case GetHomeBannerTypes.GET_HOME_BANNER_SUCCESS:
      return {...state, homeBanner: (action as GetHomeBannerSuccess).payload, loading: false, error: false};
    case GetHomeBannerTypes.GET_HOME_BANNER_FAILURE:
      return {
        ...state,
        homeBanner: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/home-banner/GetHomeBannerReducer.tsx